import { Redirect, useLocation, useParams } from 'react-router-dom';

export function AutomationFlowRedirect() {
	const location = useLocation();
	const { accountId, id } = useParams<{ accountId?: string; id?: string }>();

	if (!id) {
		return null;
	}

	return (
		<Redirect
			to={{
				pathname: accountId ? `/accounts/${accountId}/automations/${id}/canvas` : `/automations/${id}/canvas`,
				search: location.search,
				hash: location.hash,
				state: location.state,
			}}
		/>
	);
}
